const ConnectingRoadWidthGroup = {
  SIX_METER_OR_MORE: "6ｍ以上",
  FOUR_OR_MORE_LESS_THAN_SIX: "4ｍ以上 6m未満",
  LESS_THAN_FOUR: "4ｍ未満",
  UNKNOWN: "わからない",
} as const;

export type IConnectingRoadWidthGroup = typeof ConnectingRoadWidthGroup[keyof typeof ConnectingRoadWidthGroup];

export const connectingRoadWidthGroupOptions = Object.values(ConnectingRoadWidthGroup).map(value => ({ label: value, value }));

export const connectingRoadWidthGroup = (status: IConnectingRoadWidthGroup) => {
  switch (status) {
    case ConnectingRoadWidthGroup.SIX_METER_OR_MORE:
      return 1;
    case ConnectingRoadWidthGroup.FOUR_OR_MORE_LESS_THAN_SIX:
      return 2;
    case ConnectingRoadWidthGroup.LESS_THAN_FOUR:
      return 3;
    case ConnectingRoadWidthGroup.UNKNOWN:
      return 4;
    default:
      return 0;
  }
};

export default ConnectingRoadWidthGroup;
